var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarHomeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6414_3000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1699 18.938H9.13086V12.4829C9.13086 12.0337 9.43359 11.7407 9.88281 11.7407H13.4277C13.877 11.7407 14.1699 12.0337 14.1699 12.4829V18.938ZM3.04688 18.3521C3.04688 19.7095 3.86719 20.5103 5.24414 20.5103H18.0859C19.4629 20.5103 20.2734 19.7095 20.2734 18.3521V10.6177L12.2461 3.88916C11.875 3.57666 11.4355 3.58643 11.0742 3.88916L3.04688 10.6177V18.3521ZM0 9.64111C0 10.0415 0.3125 10.4224 0.839844 10.4224C1.11328 10.4224 1.33789 10.2759 1.54297 10.1099L11.3184 1.90674C11.5332 1.71143 11.7969 1.71143 12.0117 1.90674L21.7871 10.1099C21.9824 10.2759 22.207 10.4224 22.4805 10.4224C22.9395 10.4224 23.3105 10.1392 23.3105 9.67041C23.3105 9.37744 23.2129 9.18213 23.0078 9.00635L12.8418 0.461426C12.1191 -0.153809 11.2207 -0.153809 10.4883 0.461426L0.3125 9.00635C0.0976562 9.18213 0 9.4165 0 9.64111ZM17.8223 5.23682L20.2734 7.30713V2.79541C20.2734 2.36572 20 2.09229 19.5703 2.09229H18.5254C18.1055 2.09229 17.8223 2.36572 17.8223 2.79541V5.23682Z",
    fill: "#1D1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6414_3000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3105,
    height: 22.1631,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarHomeSelected);
export default __webpack_public_path__ + "static/media/tabbar-home-selected.fdfd272dbba7cb1f5fdd6b87826ca2df.svg";
export { ForwardRef as ReactComponent };